import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ColDef, GridApi, ColumnApi, EditableCallbackParams } from 'ag-grid-enterprise';
import { GridReadyEvent, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { MessageService } from 'primeng/api';
import { cardConfig } from 'src/app/cms-v2/entities/item/config/item-grid-view-config';
import { AgGridTableComponent } from 'src/app/common/ag-grid-table/ag-grid-table.component';
import { AgGridToolsService } from 'src/app/common/ag-grid-table/services/ag-grid-tools.service';
import { TableCommunicationService } from 'src/app/common/ag-grid-table/services/table-communication.service';
import { AgGridEditService } from 'src/app/common/ag-grid-table/services/ag-grid-edit.service';
import { ThemeService } from 'src/app/services/theme.service';
import { ActionsCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/actions/actions.component';
import { Subscription } from 'rxjs';


@Component({
  selector: 'table-input',
  templateUrl: './table-input.component.html',
  styleUrls: ['./table-input.component.sass'],
  providers: [
    MessageService,
    TableCommunicationService, // Provide separate instance for this component to avoid event conflicts
    {
      provide: AgGridTableComponent,
      useExisting: TableInputComponent
    }
  ],
})
export class TableInputComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('leftGrid', { static: false }) leftGrid!: AgGridAngular;
  
  @Input() field: any;
  @Input() record: any;
  @Input() isTableInput: boolean = false;
  @Input() deficolumn: ColDef[];
  @Input() entityType: string;
  @Input() options: any = {};

  @Output() onChange = new EventEmitter<any>();

  public entity: string;
  public columnDefs: ColDef[] = [];
  public leftTableColumnDefs: ColDef[] = [];
  public leftDefaultColDef: ColDef;
  public leftGridApi!: GridApi;
  public leftColumnApi!: ColumnApi;
  
  // Properties needed by ActionsCellRendererComponent
  get api(): GridApi {
    return this.leftGridApi;
  }
  
  // Return the actual editing state for ActionsCellRendererComponent (hides individual edit buttons when true)
  get isFullEditMode(): boolean {
    return this.isEditingEnabled; // Show individual row action buttons unless full edit mode is active
  }
  public gridTheme: string = 'ag-theme-alpine';
  private themeSubscription!: Subscription;
  public bulkUpdateColDefs: any[] = [];
  public columnSelection: string;
  
  // SideBar configuration for left table
  public leftGridSideBar: any = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivotMode: true
        }
      }
    ],
    position: 'right',
    defaultToolPanel: null
  };

  public autopopulateSelect: string = '';
  public buildParams: any = {};

  public cardConfig: any = new cardConfig().cardConfig;
  public tableParams: any = {};
  public rightTableParams: any = {};
  public rowData: any = [];
  public filteredRowData: any = [];
  public tableInputParams: string;
  selectedItems: any[] = [];
  
  public selectedEnvironments: any[] = [];
  
  // Left table control properties
  public filterCounter: any = null;
  public sortCounter: any = null;
  public isEditingEnabled: boolean = false;
  public isColumnsPanelVisible: boolean = false;
  
  // Row editing properties (reusing ag-grid-table pattern)
  public editingRows: Set<number> = new Set();
  public activeRowEdit: boolean = false;
  public changedRows: Map<number, any> = new Map();
  public originalData: Map<string, any> = new Map();
  
  // Row editing subscriptions
  private editRowSubscription: Subscription;
  private cancelEditRowSubscription: Subscription;
  private submitSaveRowSubscription: Subscription;
  private deleteRowSubscription: Subscription;
  
  // Column types (reusing ag-grid-table pattern)
  public columnTypes: {
    [key: string]: ColDef;
  } = {
      editableColumn: {
        editable: (params: EditableCallbackParams<any>) => {
          return this.isCellEditable(params);
        },
        cellClass: (params: any) => {
          if (this.isEditingEnabled || this.editingRows.has(params.node.rowIndex)) {
            return 'center-cell-content editing-cell';
          } else {
            return 'center-cell-content';
          }
        }
      },
    };



  constructor(
    private agGridToolsService: AgGridToolsService,
    private tableCommunicationService: TableCommunicationService,
    private agGridEditService: AgGridEditService,
    private messageService: MessageService,
    private themeService: ThemeService
  ) {
    this.autopopulateSelect = 'prefab_ref thumbnail_ref';
    
    // Initialize default column definition for left grid to match ag-grid-table
    this.leftDefaultColDef = {
      filterParams: {
        suppressAndOrCondition: true
      },
      cellClass: 'center-cell-content',
      wrapText: true,
      autoHeight: true,
      sortable: true,
      resizable: true,
      minWidth: 50,
      editable: false // Default to non-editable, enable per column as needed
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && changes['options'].currentValue) {
      console.log('TableInput options changed:', this.options);
      // Ensure envs array exists when options change
      if (!this.options) {
        this.options = {};
      }
      if (!this.options['envs']) {
        this.options['envs'] = [];
        console.warn('No envs options provided to table-input component');
      }
    }
    
    if (changes['record'] && changes['record'].currentValue) {
      console.log('TableInput record changed:', this.record);
      
      // Update field values when record changes - only for item-sets
      if (this.entityType === 'item-sets') {
        // Safely update environment fields if they exist
        if (this.record.env) {
          this.selectedEnvironments = Array.isArray(this.record.env) ? this.record.env : [];
        }
      }
      
      // Update row data if the field key data changes
      if (this.field) {
        this.rowData = Array.isArray(this.record[this.field.key]) ? this.record[this.field.key] : [];
        this.filteredRowData = [...this.rowData];
        this.updateRightTableParams();
      }
    }
  }

  async ngOnInit(): Promise<void> {
    console.log('tic entity: ', this.entity);
    console.log('TableInput options:', this.options);
    this.isTableInput = this.field.isTableInput ? this.field.isTableInput : false;

    if(this.field && this.field.tableInputParams){
      this.tableInputParams = this.field.tableInputParams;
    }

    // Ensure options object exists
    if (!this.options) {
      this.options = {};
    }

    // Ensure envs array exists
    if (!this.options['envs']) {
      this.options['envs'] = [];
      console.warn('No envs options provided to table-input component');
    }



    // Initialize field values from existing record data
    console.log('TableInput record data:', this.record);
    console.log('TableInput field data:', this.field);
    
    // Initialize environment and enabled fields only for item-sets
    if (this.entityType === 'item-sets') {
      // Only initialize if the fields don't already exist
      if (!this.record.hasOwnProperty('env')) {
        this.record.env = [];
      }
      if (!this.record.hasOwnProperty('enabled')) {
        this.record.enabled = true;
      }
      this.selectedEnvironments = Array.isArray(this.record.env) ? this.record.env : [];
    }

    this.rowData = Array.isArray(this.record[this.field.key]) ? this.record[this.field.key] : [];

    // Process thumbnails for initial data
    this.processItemThumbnails();
    
    // Update filteredRowData AFTER processing to include thumbnail_img
    this.filteredRowData = [...this.rowData];

    this.entity = this.field.entity ? this.field.entity : 'items';

    // Usa deficolumn si está disponible, de lo contrario usa columnas predeterminadas
    this.columnDefs = this.deficolumn ? this.deficolumn : [
      {
        headerName: 'ID',
        field: 'id',
        width: 125,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: true,
        initialSort: 'desc',
        sortIndex: 0,
        initialSortIndex: 0,
        sort: 'desc',
        sortingOrder: ['asc', 'desc'],
        unSortIcon: false,
        filter: 'agNumberColumnFilter',
        filterParams: {
          filterOptions: [
            'equals',
            'notEqual',
            'lessThan',
            'lessThanOrEqual',
            'greaterThan',
            'greaterThanOrEqual',
            'inRange'
          ]
        },
        resizable: true,
        floatingFilter: true,
        suppressSizeToFit: true,
      },
      {
        headerName: 'Name',
        field: 'name',
        cellRendererParams: {
          entity: 'collections'
        },
        cellRenderer: 'agGroupCellRenderer',
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        cellEditor: 'agTextCellEditor',
        type: 'editableColumn',
      },
    ];

    this.columnSelection = this.agGridToolsService.getColumnFieldNamesFromCols(this.columnDefs);

    // Configure left table column definitions to match ag-grid-table structure
    this.leftTableColumnDefs = [
      {
        headerName: 'ID',
        field: 'id',
        width: 125,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: true,
        initialSort: 'desc',
        sortIndex: 0,
        initialSortIndex: 0,
        sort: 'desc',
        sortingOrder: ['asc', 'desc'],
        unSortIcon: false,
        filter: 'agNumberColumnFilter',
        filterParams: {
          filterOptions: [
            'equals',
            'notEqual',
            'lessThan',
            'lessThanOrEqual',
            'greaterThan',
            'greaterThanOrEqual',
            'inRange'
          ],
          suppressAndOrCondition: true
        },
        resizable: true,
        floatingFilter: true,
        suppressSizeToFit: true,
      },
      {
        headerName: 'Name',
        field: 'name',
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        },
        floatingFilter: true,
        cellEditor: 'agTextCellEditor',
        cellEditorParams: {
          maxLength: 255
        },
        type: 'editableColumn',
      }
    ];

    // Add thumbnail column if enabled
    if (this.field.showthumb) {
      this.leftTableColumnDefs.push({
        headerName: 'Thumbnail',
        field: 'thumbnail_img',
        width: 80,
        sortable: false,
        filter: false,
        resizable: true,
        suppressSizeToFit: true,
        floatingFilter: false,
        cellRenderer: (params: any) => {
          if (params.value) {
            return `<img src="${params.value}" alt="Thumbnail" style="width: 100%; height: auto; max-width: 150px; min-width: 30px; border-radius: 4px;" />`;
          }
          return '<span style="font-style: italic; opacity: 0.6;">No image</span>';
        }
      });
    }

    // Add Actions column at the end (pinned to right)
    this.leftTableColumnDefs.push({
      headerName: 'Actions',
      field: 'actions',
      cellRenderer: ActionsCellRendererComponent,
      pinned: 'right',
      width: 120,
      resizable: true,
      sortable: false,
      filter: false,
      suppressSizeToFit: true,
      floatingFilter: false,
      editable: false,
      suppressNavigable: true, // Prevent keyboard navigation to this cell
      cellRendererParams: {
        enableDuplicateFeature: false,
        enableDeleteFeature: true,
        isDynamicEntity: false,
        isTableInput: true, // Custom flag to identify table-input context
        removeCallback: this.removeRowById.bind(this) // Custom remove function for table-input
      }
    });

    // Initialize right table params with exclusion query
    this.updateRightTableParams();
    
    // Subscribe to row editing events (reusing ag-grid-table pattern)
    this.editRowSubscription = this.tableCommunicationService.editRow$.subscribe((rowIndex: number) => {
      this.editingRows.add(rowIndex);
      this.activeRowEdit = true;
      this.leftGridApi.redrawRows();
    });

    this.cancelEditRowSubscription = this.tableCommunicationService.cancelEditRow$.subscribe((rowIndex: number) => {
      this.editingRows.delete(rowIndex);
      this.activeRowEdit = this.editingRows.size > 0;
      this.leftGridApi.redrawRows();
    });

    this.submitSaveRowSubscription = this.tableCommunicationService.submitSaveRow$.subscribe((rowIndex: number) => {
      this.editingRows.delete(rowIndex);
      this.activeRowEdit = this.editingRows.size > 0;
      this.leftGridApi.redrawRows();
    });
    
    // Subscribe to delete row events for table-input specific handling
    this.deleteRowSubscription = this.tableCommunicationService.deleteRow$.subscribe((payload: any) => {
      if (payload && payload.id) {
        this.removeRowById(payload.id);
      }
    });
    
    // Subscribe to theme changes to match ag-grid-table
    this.themeSubscription = this.themeService.isDark$.subscribe((isDark) => {
      this.toggleTheme(isDark);
    });
  }

  // onSearch method removed - ag-grid provides built-in filtering

  getThumbnailUrl(rowData: any): string {
    if (rowData.thumbnail_ref && rowData.thumbnail_ref.thumbnails && rowData.thumbnail_ref.thumbnails[1]) {
      return rowData.thumbnail_ref.thumbnails[1].path;
    } else {
      return 'https://d3tfb94dc03jqa.cloudfront.net/thumbnails/narrow_thumbnail_placeholder.jpeg';
    }
  }

  // Process thumbnail_img property for all items in rowData
  processItemThumbnails(): void {
    this.rowData = this.rowData.map((item: { thumbnail_ref: { thumbnails: { path: any; }[]; }; id: any; name: any; }) => {
      const thumbnailImg = item.thumbnail_ref && item.thumbnail_ref.thumbnails && item.thumbnail_ref.thumbnails[1]
        ? item.thumbnail_ref.thumbnails[1].path
        : 'https://d3tfb94dc03jqa.cloudfront.net/thumbnails/narrow_thumbnail_placeholder.jpeg';
      
      return {
        ...item,
        thumbnail_img: thumbnailImg
      };
    });
  }

  handleSelectionChange(selectedData: any[]) {
    if (!Array.isArray(this.record[this.field.key])) {
      this.record[this.field.key] = [];
    }

    const existingDataIds = this.record[this.field.key].map((data: { id: any; }) => data.id);
    const newSelectedData = selectedData.filter(data => !existingDataIds.includes(data.id));

    if (newSelectedData.length > 0) {
      this.record[this.field.key] = [...this.record[this.field.key], ...newSelectedData];
      
      // Update rowData and process thumbnails for all items
      this.rowData = [...this.record[this.field.key]];
      this.processItemThumbnails();
      this.filteredRowData = [...this.rowData];
      
      this.updateRightTableParams();
      this.onRecordChange(this.record[this.field.key]);
    }
  }

  onRecordChange(updatedItemsRef: any) {
    this.onChange.emit(updatedItemsRef);
  }

  removeRow(rowIndex: number): void {
    if (rowIndex >= 0 && rowIndex < this.filteredRowData.length) {
      const itemToRemove = this.filteredRowData[rowIndex];
      const idToRemove = itemToRemove.id;
      const nameToRemove = itemToRemove.name;

      this.filteredRowData.splice(rowIndex, 1);
      this.filteredRowData = [...this.filteredRowData];

      const originalRowIndex = this.rowData.findIndex((item: { id: any; }) => item.id === idToRemove);
      if (originalRowIndex !== -1) {
        this.rowData.splice(originalRowIndex, 1);
        this.rowData = [...this.rowData];
      }

      this.record[this.field.key] = this.filteredRowData;
      this.updateRightTableParams();

      this.messageService.add({
        severity: 'success',
        summary: 'Item Removed',
        detail: `Item "${nameToRemove}" has been removed.`,
        life: 3000
      });

      this.onRecordChange(this.record[this.field.key]);
    } else {
      console.error(`Invalid rowIndex: ${rowIndex}`);
    }
  }

  deleteSelectedItems(): void {
    if (this.selectedItems && this.selectedItems.length > 0) {
      const itemsToRemoveCount = this.selectedItems.length;

      this.rowData = this.rowData.filter((row: any) => !this.selectedItems.includes(row));
      this.filteredRowData = this.filteredRowData.filter((row: any) => !this.selectedItems.includes(row));

      this.selectedItems = [];

      this.record[this.field.key] = this.filteredRowData;
      this.updateRightTableParams();

      this.messageService.add({
        severity: 'success',
        summary: 'Items Removed',
        detail: `${itemsToRemoveCount} items have been removed.`,
        life: 3000
      });

      this.onRecordChange(this.record[this.field.key]);
    } else {
      console.error('No items selected for deletion.');
    }
  }

  handleItemsGenerated(items: any[]): void {
    if (!Array.isArray(this.record[this.field.key])) {
      this.record[this.field.key] = [];
    }

    const existingIds = this.record[this.field.key].map((item: { id: any; }) => item.id);

    const newUniqueItems = items.filter(item => !existingIds.includes(item.id));

    if (newUniqueItems.length > 0) {
      this.record[this.field.key] = [...this.record[this.field.key], ...newUniqueItems];
      
      // Update rowData and process thumbnails for all items
      this.rowData = [...this.record[this.field.key]];
      this.processItemThumbnails();
      this.filteredRowData = [...this.rowData];
      
      this.updateRightTableParams();

      this.messageService.add({
        severity: 'success',
        summary: 'Items Added',
        detail: `${newUniqueItems.length} items have been added.`,
        life: 3000
      });

      this.onRecordChange(this.record[this.field.key]);
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'No New Items',
        detail: 'No new items were added because they already exist in the list.',
        life: 3000
      });
    }
  }







  onFieldValueChange(fieldKey: string, event: any): void {
    console.log('Field value change:', fieldKey, event);
    
    if (fieldKey === 'env') {
      // Handle p-multiSelect event structure
      const newValue = event && event.value ? event.value : (Array.isArray(event) ? event : []);
      this.selectedEnvironments = newValue;
      this.record.env = this.selectedEnvironments;
      this.onChange.emit({
        type: 'environment_change',
        value: this.selectedEnvironments,
        record: this.record
      });
    } else if (fieldKey === 'enabled') {
      // Handle p-toggleButton event structure
      const newValue = event && event.checked !== undefined ? event.checked : event;
      this.record.enabled = newValue;
      this.onChange.emit({
        type: 'enabled_change',
        value: newValue,
        record: this.record
      });
    } else {
      const value = event && event.value !== undefined ? event.value : event;
      this.record[fieldKey] = value;
      this.onChange.emit({
        type: fieldKey + '_change',
        value: value,
        record: this.record
      });
    }
  }

  clearEnvironments(): void {
    this.record['env'] = [];
    this.selectedEnvironments = [];
    this.onChange.emit({
      type: 'environment_change',
      value: [],
      record: this.record
    });
  }

  // Handle left grid ready event
  onLeftGridReady(params: GridReadyEvent): void {
    this.leftGridApi = params.api;
    this.leftColumnApi = params.columnApi;
    
    // Auto-size columns to fit content
    this.leftGridApi.sizeColumnsToFit();
  }

  // Handle left grid selection changes
  onLeftGridSelectionChanged(event: SelectionChangedEvent): void {
    this.selectedItems = this.leftGridApi.getSelectedRows();
  }



  // Get row class for styling (highlight generated items)
  getRowClass = (params: any) => {
    if (params.data && params.data.isGenerated) {
      return 'generated-item';
    }
    return '';
  }

  // Get left grid height to match ag-grid-table
  getLeftGridHeight(): string {
    return this.field?.height || '70vh';
  }

  // Toggle columns panel
  toggleColumnsPanel(): void {
    this.isColumnsPanelVisible = !this.isColumnsPanelVisible;
    if (this.leftGridApi) {
      if (this.isColumnsPanelVisible) {
        this.leftGridApi.openToolPanel('columns');
      } else {
        this.leftGridApi.closeToolPanel();
      }
    }
  }

  // Remove item by ID (for action column click)
  removeRowById(id: number): void {
    const rowIndex = this.filteredRowData.findIndex((item: { id: any; }) => item.id === id);
    if (rowIndex !== -1) {
      this.removeRow(rowIndex);
    }
  }

  // Update right table params to exclude selected items
  updateRightTableParams(): void {
    // Get IDs of currently selected items
    const selectedItemIds = this.filteredRowData.map((item: { id: any; }) => item.id);
    
    // Create base table params
    this.rightTableParams = {
      ...this.tableParams
    };
    
    // Add exclusion query if there are selected items
    if (selectedItemIds.length > 0) {
      this.rightTableParams.defaultQuery = {
        ...this.tableParams.defaultQuery,
        id: { $nin: selectedItemIds }
      };
    } else {
      // If no selected items, just use the original defaultQuery
      this.rightTableParams.defaultQuery = this.tableParams.defaultQuery || null;
    }
  }

  ngAfterViewInit(): void {
    // No longer needed - using standard ActionsCellRendererComponent
  }

  // Toggle theme to match ag-grid-table
  toggleTheme(isDark: boolean): void {
    this.gridTheme = isDark ? 'ag-theme-alpine-dark' : 'ag-theme-alpine';
  }

  // Clear all filters on the left table
  clearLeftTableFilters(): void {
    if (this.leftGridApi) {
      this.leftGridApi.setFilterModel(null);
      this.filterCounter = null;
      
      this.messageService.add({
        severity: 'success',
        summary: 'Filters Cleared',
        detail: 'All filters have been cleared from the table',
        life: 2000
      });
    }
  }

  // Clear all sorting on the left table
  clearLeftTableSorting(): void {
    if (this.leftColumnApi) {
      this.leftColumnApi.applyColumnState({
        defaultState: { sort: null }
      });
      this.sortCounter = null;
      
      this.messageService.add({
        severity: 'success',
        summary: 'Sorting Cleared', 
        detail: 'All sorting has been cleared from the table',
        life: 2000
      });
    }
  }


  // Update filter counter when filters change
  onLeftTableFilterChanged(): void {
    if (this.leftGridApi) {
      const filterModel = this.leftGridApi.getFilterModel();
      this.filterCounter = filterModel ? Object.keys(filterModel).length : null;
    }
  }

  // Update sort counter when sorting changes
  onLeftTableSortChanged(): void {
    if (this.leftColumnApi) {
      const sortState = this.leftColumnApi.getColumnState();
      const sortedColumns = sortState.filter(col => col.sort !== null);
      this.sortCounter = sortedColumns.length > 0 ? sortedColumns.length : null;
    }
  }

  // Toggle editing mode for the left table (called by input switch)
  toggleLeftTableEditing(): void {
    // Note: isEditingEnabled is already toggled by the input switch binding
    // Update column definitions to enable/disable editing
    this.updateColumnEditability();
    
    const message = this.isEditingEnabled ? 'Full edit mode enabled' : 'Full edit mode disabled';
    this.messageService.add({
      severity: 'info',
      summary: 'Edit Mode',
      detail: message,
      life: 1500
    });
  }

  // Standard submitFullEdit method (matching ag-grid-table pattern)
  async submitFullEdit(): Promise<void> {
    // Stop any cell that is currently being edited and commit its value
    if (this.leftGridApi) {
      this.leftGridApi.stopEditing();
    }
    
    // Wait a tick to ensure all cell value changes have been processed
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Get all record IDs of changed rows
    const changedRecordIds = Array.from(this.changedRows.keys());

    console.log('submitFullEdit - record IDs:', changedRecordIds);

    // Initialize an array to store the promises
    const promises = [];
    // Loop through each record ID and call submitRow
    for (const recordId of changedRecordIds) {
      const promise = this.agGridEditService.submitRow(
        recordId, 
        this.changedRows, 
        this.leftGridApi, 
        'items', 
        null, 
        null, 
        null, 
        false
      );
      promises.push(promise);
    }
    
    // Wait for all promises to resolve
    try {
      await Promise.all(promises);
      // All rows have been submitted successfully
      this.isEditingEnabled = false;
      this.toggleLeftTableEditing();
      
      // Emit the updated data
      this.onChange.emit({
        type: 'bulk_save',
        value: this.record[this.field.key],
        record: this.record
      });
      
      this.messageService.add({
        severity: 'success',
        summary: 'Changes Saved',
        detail: `Successfully saved ${changedRecordIds.length} item(s)`,
        life: 3000
      });
      
    } catch (error) {
      // Handle error
      console.error("An error occurred while submitting rows:", error);
      this.messageService.add({
        severity: 'error',
        summary: 'Save Error',
        detail: 'Failed to save some changes',
        life: 3000
      });
    }
  }

  // Update column definitions to enable/disable editing
  private updateColumnEditability(): void {
    if (this.leftTableColumnDefs && this.leftGridApi) {
      // Redraw rows to update editability based on current state
      this.leftGridApi.redrawRows();
    }
  }

  // Check if a cell is editable (reusing ag-grid-table pattern)
  isCellEditable(params: any): boolean {
    // If full edit mode is on, return true
    if (this.isEditingEnabled) {
      return true;
    }
    const rowIndex = params.node.rowIndex;
    return this.editingRows.has(rowIndex);
  }

  // Handle cell value changes (reusing ag-grid-table pattern)
  onCellValueChanged(event: any): void {
    const recordId = event.data.id;  // Use the record's ID instead of rowIndex
    const field = event.column.getColId();
    const newValue = event.newValue;
    const oldValue = event.oldValue;
    const colDef = event.column.getUserProvidedColDef();

    // Skip if the value didn't actually change
    if (newValue === oldValue) {
      return;
    }

    // Store the original cell value if this is the first change for the cell
    const originalCellKey = `${recordId}-${field}`;
    if (!this.originalData.has(originalCellKey)) {
      this.originalData.set(originalCellKey, oldValue);
    }

    // Initialize the map for the row if not already present
    if (!this.changedRows.has(recordId)) {
      this.changedRows.set(recordId, {});
    }

    // Update the changed value for the field
    const rowChanges = this.changedRows.get(recordId);
    rowChanges[field] = this.agGridEditService ? 
      this.agGridEditService.convertValueForDB(field, newValue, colDef) : 
      newValue;
    this.changedRows.set(recordId, rowChanges);

    // Update local data arrays
    const rowIndex = event.node.rowIndex;
    if (this.filteredRowData[rowIndex]) {
      this.filteredRowData[rowIndex][field] = newValue;
    }
    
    const originalRowIndex = this.rowData.findIndex((item: any) => item.id === recordId);
    if (originalRowIndex !== -1) {
      this.rowData[originalRowIndex][field] = newValue;
    }
    
    // Update the record data
    this.record[this.field.key] = [...this.filteredRowData];
  }

  // Row editing methods using TableCommunicationService (like ag-grid-table)
  editRow(rowIndex: number): void {
    // Individual row editing works independently of full edit mode
    // Use the communication service to trigger row editing
    this.tableCommunicationService.editRow(rowIndex);
    
    this.messageService.add({
      severity: 'info',
      summary: 'Row Edit Mode',
      detail: 'Row editing enabled. Click cells to edit.',
      life: 2000
    });
  }

  saveRow(rowIndex: number, recordId: number): void {
    // Stop any cell that is currently being edited and commit its value
    this.leftGridApi.stopEditing();
    
    // Use the AgGridEditService to submit the row (like ag-grid-table)
    this.agGridEditService.submitRow(recordId, this.changedRows, this.leftGridApi, 'items', null, null, null, false).then(() => {
      // Emit change event to parent
      this.onChange.emit({
        type: 'row_edited',
        value: this.record[this.field.key],
        editedItem: this.filteredRowData.find((item: any) => item.id === recordId),
        record: this.record
      });
      
      this.messageService.add({
        severity: 'success',
        summary: 'Row Saved',
        detail: 'Row changes have been saved',
        life: 2000
      });
      
      // Use the communication service to trigger save completion
      this.tableCommunicationService.submitSaveRow(rowIndex);
    }).catch(error => {
      console.error('Error saving row:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Save Error',
        detail: 'Failed to save row changes',
        life: 2000
      });
    });
  }

  cancelRow(rowIndex: number): void {
    // Use the communication service to cancel row editing
    this.tableCommunicationService.cancelEditRow(rowIndex);
    
    this.messageService.add({
      severity: 'info',
      summary: 'Edit Cancelled',
      detail: 'Row changes have been cancelled',
      life: 2000
    });
  }

  ngOnDestroy(): void {
    // Clean up row editing subscriptions
    if (this.editRowSubscription) {
      this.editRowSubscription.unsubscribe();
    }
    if (this.cancelEditRowSubscription) {
      this.cancelEditRowSubscription.unsubscribe();
    }
    if (this.submitSaveRowSubscription) {
      this.submitSaveRowSubscription.unsubscribe();
    }
    if (this.deleteRowSubscription) {
      this.deleteRowSubscription.unsubscribe();
    }
    
    // Clean up theme subscription
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
    
    // No longer needed - using standard ActionsCellRendererComponent
  }
}
